// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React, { useState } from 'react';
import { DefaultButton, IModalStyles, ITextStyles, Modal, Stack, Text } from '@fluentui/react';
import { JoinTeamsMeetingTextField } from './JoinTeamsMeetingTextField';
import { JoinCallButton, JoinCallIdentityKind } from './JoinCallButton';

export const JoinTeamsMeetingModal = (props: {
  isOpen: boolean;
  onCancel: () => void;
  onJoinCall: (identityType: JoinCallIdentityKind, url: string) => Promise<void>;
}): JSX.Element => {
  const [url, setUrl] = useState<string>();

  return (
    <Modal isOpen={props.isOpen} styles={modalStyles} onDismiss={props.onCancel}>
      <Stack tokens={{ childrenGap: '2rem' }}>
        <Stack.Item>
          <Text styles={headingTestStyles}>Join Teams meeting from link</Text>
        </Stack.Item>
        <Stack.Item>
          <JoinTeamsMeetingTextField value={url} onChange={(_, newValue) => setUrl(newValue)} />
        </Stack.Item>
        <Stack.Item align="end">
          <Stack horizontal tokens={{ childrenGap: '1rem' }}>
            <Stack.Item>
              <JoinCallButton
                primary={true}
                disabled={!url}
                onJoinClick={async (identity) => {
                  if (!url) {
                    throw new Error('No Teams URL provided to join');
                  }
                  await props.onJoinCall(identity, url);
                }}
              />
            </Stack.Item>
            <Stack.Item>
              <DefaultButton text="Cancel" onClick={props.onCancel} />
            </Stack.Item>
          </Stack>
        </Stack.Item>
      </Stack>
    </Modal>
  );
};

const modalStyles: Partial<IModalStyles> = {
  main: {
    padding: '2rem'
  }
};

const headingTestStyles: ITextStyles = {
  root: {
    fontWeight: '600',
    fontSize: '1.5rem'
  }
};
